module.exports = __webpack_public_path__ + "img/inco1.4850b224.png";